import React from 'react';
import { Space } from 'antd';
import PurchaseListTemplate from '../../../pages/purchase/components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../../../pages/purchase/purchase.effect';
import PurchaseTriggerActionMap, { PurchaseTriggerActionProvider, PurchaseTriggerTarget } from '../../../pages/purchase/components/PurchaseTriggerActionMap';

const PurchasePendingQuoteList: React.FC = () => {
  const [refreshKey, setRefreshKey] = React.useState(0);
  const reloadList = () => setRefreshKey((k) => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.QuotePending);

  const renderTableActions = React.useCallback((order: PurchaseInfo) => {
    // Only target is to upload purchase info
    const targets: PurchaseTriggerTarget[] = ['uploadPurchaseInfo'];
    return (
      <Space size={[8, 8]} wrap>
        {targets.length > 0 && <PurchaseTriggerActionMap targets={targets} purchase={order} onReload={reloadList} />}
      </Space>
    );
  }, []);

  return (
    <PurchaseTriggerActionProvider onReload={reloadList}>
      <PurchaseListTemplate
        title="待报价列表"
        refreshKey={refreshKey}
        queryFields={queryFields}
        tabScene={PurchaseTabScene.QuotePending}
        defaultScene={PurchaseTabScene.QuotePending}
        viewModes={React.useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            showField: 'tab_quote_pending'
          },
        ], [renderTableActions])}
      />
    </PurchaseTriggerActionProvider>
  );
};

export default PurchasePendingQuoteList;
